import { RotateCcw, X } from 'lucide-react';

import { formatarDataHora } from '@/nucleo/formato/datas';
import { Alert, AlertDescription } from '@/ui/base/alert';
import { Button } from '@/ui/base/button';

interface AvisoDeRascunhoProps {
  aoRestaurar: () => void;
  aoDescartar: () => void;
  /** Data/hora da ultima gravacao local. Sem ela, o aviso nao mostra "Salvo em...". */
  gravadoEm?: Date | null;
}

/** Aviso de que ha um rascunho deste formulario salvo neste navegador. */
export function AvisoDeRascunho({ aoRestaurar, aoDescartar, gravadoEm }: AvisoDeRascunhoProps) {
  return (
    <Alert className="border-primary/30 bg-primary/5">
      <RotateCcw className="h-4 w-4 text-primary" aria-hidden="true" />
      <AlertDescription className="flex w-full flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex flex-col">
          <span className="text-sm">Encontramos um rascunho deste formulário neste navegador.</span>
          {gravadoEm && (
            <span className="text-xs text-muted-foreground">
              Salvo em {formatarDataHora(gravadoEm)}
            </span>
          )}
        </div>
        <div className="flex gap-2 sm:ml-4">
          <Button type="button" size="sm" variant="outline" onClick={aoDescartar}>
            <X className="mr-1 h-3 w-3" aria-hidden="true" />
            Descartar
          </Button>
          <Button type="button" size="sm" onClick={aoRestaurar}>
            <RotateCcw className="mr-1 h-3 w-3" aria-hidden="true" />
            Restaurar
          </Button>
        </div>
      </AlertDescription>
    </Alert>
  );
}
